import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

// import Extension from "./views/Extension.vue";
// import WeChat from "./views/WeChat.vue";
// import Headlines from "./views/Headlines.vue";
// import Adserve from "./views/Adserve.vue";
// import ContactUs from "./views/ContactUs.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  // 页面切换后 新页面内容显示页面顶部内容
  scrollBehavior(to, from, savedPosition) {
    console.log("显示顶部");

    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },

  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/Home",
      name: "Home",
      component: () => import("./views/Home.vue")
    },
    // // Home  Extension  WeChat   Headlines   Adserve ContactUs
    {
      path: "/Extension",
      name: "Extension",
      component: () => import("./views/Extension.vue")
    },
    {
      path: "/WeChat",
      name: "WeChat",
      component: () => import("./views/WeChat.vue")
    },
    {
      path: "/Headlines",
      name: "Headlines",
      component: () => import("./views/Headlines.vue")
    },
    {
      path: "/Adserve",
      name: "Adserve",
      component: () => import("./views/Adserve.vue")
    },
    {
      path: "/ContactUs",
      name: "ContactUs",
      component: () => import("./views/ContactUs.vue")
    },

    {
      path: "/InformationPromotion",
      name: "InformationPromotion",
      component: () => import("./Subpages/InformationPromotion.vue")
    },
    // {
    //   path: "/ASOPromotion",
    //   name: "ASOPromotion",
    //   component: () => import("./Subpages/ASOPromotion.vue")
    // },
    {
      path: "/GlobalMarketing",
      name: "GlobalMarketing",
      component: () => import("./Subpages/GlobalMarketing.vue")
    },

    // newmediapromotion

    {
      path: "/newmediapromotion",
      name: "newmediapromotion",
      component: () => import("./Subpages/newmediapromotion.vue")
    },

    {
      path: "/Marketpromotion",
      name: "Marketpromotion",
      component: () => import("./Subpages/Marketpromotion.vue")
    },

    // ShortVideoPromotion
    {
      path: "/ShortVideoPromotion",
      name: "ShortVideoPromotion",
      component: () => import("./Subpages/ShortVideoPromotion.vue")
    },
     {
      path: "/Wjxh",
      name: "Wjxh",
      component: () => import("./views/Wjxh.vue")
    }


  ]
});
